import { useMutation, useQueryClient } from '@tanstack/react-query';
import { ambientApi } from 'src/services';

export type MedicineItemToDelete = {
  order_type_id: string;
};

export type DeleteMedicineSummaryParams = {
  encounterId: string;
  medicines: MedicineItemToDelete[];
};

type DeleteMedicineSummaryResponse = {
  message: string;
};

export const useDeleteMedicineSummary = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({
      encounterId,
      medicines,
    }: DeleteMedicineSummaryParams) => {
      const response = await ambientApi.delete<DeleteMedicineSummaryResponse>(
        `/encounter/${encounterId}/medicines`,
        { data: { medicines } }
      );
      return response.data;
    },
    onSuccess: (_, variables) => {
      // Invalidate and refetch medicine summaries for this encounter
      queryClient.invalidateQueries({
        queryKey: ['summaries', variables.encounterId, 'in-visit', 'medicine'],
      });

      // Also invalidate the general summaries query
      queryClient.invalidateQueries({
        queryKey: ['summaries', variables.encounterId],
      });
    },
  });
};
